var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemoveRow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 6.1l4.4 4.4c.4.4.4 1 0 1.4s-1 .4-1.4 0L6.1 7.6 1.7 12c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l4.4-4.4L.3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0l4.4 4.4L10.5.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L7.6 6.1z"
  })));
}
export default SvgIconRemoveRow;